module.exports = __webpack_public_path__ + "static/media/Niveau_elN15_1_114666.1f364749.png";